export const getRWMotorPrivateInsuranceState = (state) => state?.motorPrivateRW;
